import React from "react";
import styled from "styled-components";
import one from "./ASSESTS/Food/beans.jpg";
import two from "./ASSESTS/Food/chickenlap.jpg";
import three from "./ASSESTS/Food/garri.jpg";
import four from "./ASSESTS/Food/bucpepper.png";
import { Link } from "react-router-dom";
const Discover = () => {
  return (
    <div>
      <Container>
        <Wrapper>
          <h1 style={{marginLeft:"20px", textAlign:"center"}}>
            Discover more. <span>Good things are waiting for you</span>
          </h1>
          <Holder>
            <Card>
              <One>
                <DivOne>
                  <p>Explore new arrivals</p>
                  <h2>Shop the latest from top brands</h2>
                </DivOne>
                <DivTwo>
                  <Button to="/product">View all</Button>
                </DivTwo>
              </One>
              <Two>
                <img style={{borderRadius:"10px"}}  src={one} alt="" />
              </Two>
            </Card>
            <Card1>
              <One>
                <DivOne>
                  <p>Explore new arrivals</p>
                  <h2>Shop the latest from top brands</h2>
                </DivOne>
                <DivTwo>
                <Button to="/product">View all</Button>
                </DivTwo>
              </One>
              <Two>
                <img style={{borderRadius:"10px"}}  src={two} alt="" />
              </Two>
            </Card1>
            <Card2>
              <One>
                <DivOne>
                  <p>Explore new arrivals</p>
                  <h2>Shop the latest from top brands</h2>
                </DivOne>
                <DivTwo>
                <Button to="/product">View all</Button>
                </DivTwo>
              </One>
              <Two>
                <img style={{borderRadius:"10px"}}  src={three} alt="" />
              </Two>
            </Card2>
            <Card3>
            <One>
              <DivOne>
                <p>Explore new arrivals</p>
                <h2>Shop the latest from top brands</h2>
              </DivOne>
              <DivTwo>
              <Button  to="/product">View all</Button>
              </DivTwo>
            </One>
            <Two>
            <img style={{borderRadius:"10px"}} src={four} alt="" />
            </Two>
          </Card3>
          </Holder>
        </Wrapper>
      </Container>
    </div>
  );
};

export default Discover;

const Holder = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  width: 100%;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
  align-items: center;
    /* margin-top: 50px; */
    /* background-color: #e3ffe6; */
    
  
  }
`;

const Card3 = styled.div`
  width: 350px;
  height: 250px;
  /* background-color: #D2CDEB; */
  /* background-color: #296E3C; */
  background-color: #09E85E;
  /* background-color: #eaded0; */
  border-radius: 10px;
  display: flex;
  padding-bottom: 10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    width: 280px;
    margin-bottom: 20px;
    margin-left: 10px;
    padding-bottom: 20px;
  }

   img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Card2 = styled.div`
  width: 350px;
  height: 250px;
  /* background-color: lightblue; */
  /* background-color: #296e3db8; */
  /* background-color: #eaded0; */
  border-radius: 10px;
  display: flex;
  padding-bottom: 10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  @media screen and (max-width: 768px) {
    width: 280px;
    margin-bottom: 20px;
    margin-left: 10px;
    padding-bottom: 20px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Card1 = styled.div`
  width: 350px;
  height: 250px;
  /* background-color: lightpink; */
  background-color: #09E85E;
  /* background-color: #eaded0; */
  border-radius: 10px;
  display: flex;
  padding-bottom: 10px;
  display: flex;
  margin-left: 20px;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  @media screen and (max-width: 768px) {
    width: 280px;
    margin-bottom: 20px;
    margin-left: 10px;
    padding-bottom: 20px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Two = styled.div`
  width: 150px;
  height: 150px;
  margin-left: 10px;
  border-radius: 10px;
  /* background-color: lightgray; */
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; */
  @media screen and (max-width: 768px) {
    width: 130px;
  height: 130px;
    margin-right: 10px;
  }
`;

const Button = styled(Link)`
  width: 150px;
  height: 50px;
  background-color: white;
  color: black;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 35px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
font-size: 14px;
text-decoration: none;
  @media screen and (max-width: 768px) {
    width: 100px;
  height: 50px;
    
  
  }

`;

const DivTwo = styled.div``;

const DivOne = styled.div`
  text-align: left;
  padding-left: 35px;

  p{
    font-size: 15px;
  }

  h2{
    font-size: 20px;
  }
`;

const One = styled.div`
  width: 50%;
`;

const Card = styled.div`
  width: 350px;
  height: 250px;
  /* background-color: #ffff0021; */
  /* background-color: #eaded0; */
  border-radius: 10px;
  display: flex;
  padding-bottom: 10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  @media screen and (max-width: 768px) {
    width: 280px;
    margin-bottom: 20px;
    margin-left: 10px;
    padding-bottom: 20px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Wrapper = styled.div`
  width: 100%;

  h1 {
    color: black;
    text-align: left;
    margin-top: 80px;
    margin-bottom: 30px;
margin-left: 50px;
    span {
      color: #292929;
    }
  }

  
`;

const Container = styled.div`
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  
`;
